<template>
  <div
    v-if="displayList"
    class="suggestion-list-container flex flex-col"
  >
    <template v-for="(item, index) in list">
      <div
        v-if="item.status === 'not_answered' || item.status === 'answered'"
        :key="index"
        class="suggestion-list-item flex items-start"
        :class="item.impact"
      >
        <div
          class="content flex-1 select-text"
          :class="{'resolved': item.status === 'answered'}"
        >
          {{ item.content }}
        </div>
        <div
          class="ignore flex-shrink-0 flex items-center"
          :class="{'cursor-pointer': item.status === 'not_answered'}"
          @click.stop="clickIgnore(item)"
        >
          <i v-if="item.status === 'answered'" class="iconfont iconxuanzhong"></i>
          {{ item.status === 'answered' ? '已优化' : '忽略' }}
        </div>
      </div>
    </template>
    <div
      v-if="!hiddenBottomBtn"
      class="flex items-center button-group"
    >
      <button
        class="btn-item flex-1 flex justify-center items-center"
        @click="clickAiCheck"
      >
        <i class="iconfont iconhuanyihuan1"></i>
        重新检查
      </button>
      <button
        v-if="isMembership"
        class="btn-item flex-1 flex justify-center items-center"
        @click="clickRepairIssue"
      >
        <i class="iconfont iconFrame1"></i>
        一键修复问题
      </button>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import CompleteButton from '../../components/CompleteButton/CompleteButton.vue';
export default {
  name: 'CheckSuggestionList',
  components: {
    CompleteButton,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    hiddenBottomBtn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState('me', ['isMembership']),
    displayList() {
      return this.list.some((item) => item.status === 'not_answered' || item.status === 'answered');
    },
  },
  methods: {
    clickRepairIssue() {
      this.$emit('clickRepairIssue');
    },
    clickIgnore(item) {
      if (item.status === 'answered') return;
      this.$emit('clickIgnore', item);
    },
    clickAiCheck() {
      this.$emit('clickAiCheck');
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/variable.scss';
.suggestion-list-container {
  gap: 10px;
  .suggestion-list-item {
    position: relative;
    color: $text-color;
    background-color: $resume-check-suggestion-bg-color;
    padding: 12px 18px 12px 22px;
    border-radius: 6px;
    overflow: hidden;
    &::before {
      content: '';
      display: inline-block;
      position: absolute;
      left: 0;
      top: 0;
      width: 6px;
      height: 100%;
    }
    &.LOW::before {
      background: linear-gradient(to right, $resume-check-low-start-color, $resume-check-low-end-color);
    }
    &.MEDIUM::before {
      background: linear-gradient(to right, $resume-check-medium-start-color, $resume-check-medium-end-color);
    }
    &.HIGH::before {
      background: linear-gradient(to right, $resume-check-high-start-color, $resume-check-high-end-color);
    }
    .content {
      user-select: text;
      &.resolved {
        text-decoration: line-through;
        opacity: 0.6;
      }
    }
    .ignore {
      font-size: 14px;
      color: $resume-check-suggestion-ignore-color;
      margin-left: 18px;
      .iconxuanzhong {
        margin-right: 6px;
        color: $text-color;
        opacity: 0.6;
      }
    }
  }
  .button-group {
    display: flex;
    gap: 16px;
    margin-top: 18px;
    .btn-item {
      color: $text-color;
      border: 1px solid $advice-border-color;
      border-radius: 6px;
      height: 42px;
      i {
        margin-right: 4px;
      }
    }
  }
}
</style>
